import { DateTime } from "luxon";
import { UnavailabilitiesFilter } from "@planzone/dto";

function match(first: UnavailabilitiesFilter, second: UnavailabilitiesFilter) {
  return (
    first.startDate === second.startDate && first.endDate === second.endDate
  );
}

function isInDateRange(first: UnavailabilitiesFilter, date: string) {
  const d = DateTime.fromISO(date, { zone: "utc" });
  const start = DateTime.fromISO(first.startDate, { zone: "utc" });
  const end = DateTime.fromISO(first.endDate, { zone: "utc" });

  return d.isValid && start.isValid && end.isValid && start <= d && d <= end;
}

export { match, isInDateRange };
